import React from 'react';

import IForm from '../../../../types/IForm';
import Form from '../../../molecules/Form/Form';
import { ElementType } from '../../../../types/api/ElementType';
import PasswordResetTemplate from './templates/PasswordResetTemplate';
import PasswordForgotTemplate from './templates/PasswordForgotTemplate';

const getTemplate = (elementType: string) => {
  if (elementType === ElementType.passwordresetform) {
    return <PasswordResetTemplate />;
  }
  return <PasswordForgotTemplate />;
};

type PasswordResetFormType = { model: IForm; elementType: string };

export function PasswordResetForm({ model, elementType }: PasswordResetFormType) {
  return (
    <div className="password-reset">
      <Form id="password-reset-form" model={model}>
        {getTemplate(elementType)}
      </Form>
    </div>
  );
}
